<template>
    <div :class="['page page--light', { 'page--embed': partnerAppEmbedCustomization }]">
        <section class="
        row
        gradient-background"
        >
            <div class="wrapper wrapper--no-max-width">
                <header class="row__header">
                    <back-button :isAbsolute="false"
                        :isBlack="true"
                    />

                    <h1>{{ headerText }}</h1>
                </header>

                <wallet-form :header="amountTitle"
                    :title="description"
                    :isButtonShow="!isTradingRestricted"
                    :isButtonDisabled="isButtonDisabled"
                    :buttonText="buttonText"
                    :isTimerShown="true"
                    :duration="timer"
                    :isSellPage="isSellPage"
                    :isFT="isFT"
                    :termsTextList="termsTextList"
                    :disclaimerConfig="disclaimerConfig"
                    @toggledTerms="onToggledTerms"
                    @proceedButtonAction="proceedButtonAction"
                    @timerFinished="finishedTimer"
                    @tick="onRemaining"
                >
                    <template v-if="!isInit && shouldShowLimitsInfo"
                        #headerRightElement
                    >
                        <context-menu :items="contextMenuItems" />
                    </template>

                    <template>
                        <div class="fto-form">
                            <div v-if="isSellPage"
                                class="balance balance--top"
                            >
                                {{ balanceText }}
                            </div>

                            <div :class="['fto-form__input', { 'fto-form__input--padding-bottom': !shouldShowInputValidation }]">
                                <span>{{ symbol }}</span>

                                <input v-debounce:300ms="fetchEstimates"
                                    v-autofocus
                                    type="number"
                                    placeholder="0"
                                    :disabled="isInputDisabled"
                                    :value="tokenAmountFormatted"
                                    :class="[{ 'fto-form__input--error': areLimitsExceeded || !hasEnoughBalance }]"
                                    @input="onChangeTokenAmount"
                                    @keypress="preventDecimalInput"
                                >

                                <span v-if="shouldShowInputValidation"
                                    :class="['input-validation', { 'fto-form__input--error': areLimitsExceeded || !hasEnoughBalance }]"
                                >
                                    {{ inputValidationText }}
                                </span>
                            </div>

                            <exchange-rate :conversionRateInfo="conversionRateInfo"
                                class="exchange-rate"
                            />

                            <div :class="`fto-form__input fto-form__input--${isSellPage ? 'blue' : 'orange'}`">
                                <span>{{ centralizedWallet.currency.shortCode }}</span>

                                <input type="text"
                                    placeholder="0"
                                    disabled
                                    :value="formattedValue"
                                >

                                <div v-if="!isSellPage"
                                    class="balance"
                                >
                                    {{ balanceText }}
                                </div>
                            </div>

                            <div v-if="isFT"
                                class="fto-form__fees"
                            >
                                <div class="fto-form__fees-fee">
                                    {{ $t('buyTokensConfirmation.tradingMargin', { shortCode: centralizedCurrencyShortCodeFormatted }) }}

                                    <span>{{ formattedMarginAmount }}</span>
                                </div>

                                <div class="fto-form__fees-fee">
                                    {{ $t('buyTokensConfirmation.serviceFee', { shortCode: centralizedCurrencyShortCodeFormatted }) }}

                                    <span>{{ formattedFeeAmount }}</span>
                                </div>
                            </div>
                        </div>
                    </template>

                    <template v-slot:side-content>
                        <div class="side-content">
                            <div class="side-content__row">
                                <partner-logo :show-placeholder="false"
                                    :url="partner.partnerLogo"
                                />

                                <div class="side-content__column side-content__column--align-right">
                                    <span>{{ tokenRatesInCurrency.main }}</span>

                                    <span v-if="isChzAllowed">{{ `≈ ${tokenRatesInCurrency.alt}` }}</span>
                                </div>
                            </div>

                            <div class="side-content__row">
                                <div class="side-content__title">{{ $t('tokenDetails.tokenSummary') }}</div>

                                <span v-if="isTextLong">
                                    {{ shortText }}

                                    <span class="side-content__show-more"
                                        @click="showMore"
                                    >
                                        {{ $t('tokenDetails.showMore') }}
                                    </span>
                                </span>

                                <span v-else>{{ tokenDetails.description }}</span>
                            </div>

                            <div v-if="isFT">
                                <div v-if="market.id && isChzAllowed"
                                    class="side-content__row"
                                >
                                    <div class="side-content__title side-content__title--padding-top">{{ $t('tokenDetails.trading') }}</div>

                                    <token-price-chart v-if="market.id"
                                        :marketId="market.id"
                                    />

                                    <span class="side-content__chart-timeframe">Last Month</span>
                                </div>
                            </div>

                            <div v-else>
                                <div class="side-content__row">
                                    <div class="side-content__title">{{ $t('tokenDetails.FTO') }}</div>

                                    <div class="side-content__title side-content__title--padding-top">{{ $t('tokenDetails.totalSupply') }}</div>

                                    {{ tokenDetails.supply }}
                                </div>

                                <div class="side-content__row">
                                    <div class="side-content__column">
                                        <div class="side-content__title">{{ $t('tokenDetails.ftoStartDate') }}</div>

                                        {{ tokenOfferingDetails.startDate }}
                                    </div>

                                    <div class="side-content__column side-content__column--time">
                                        <div class="side-content__title">{{ $t('tokenDetails.time') }}</div>

                                        {{ tokenOfferingDetails.startTime }}
                                    </div>
                                </div>

                                <div class="side-content__row">
                                    <div class="side-content__column">
                                        <div class="side-content__title">{{ $t('tokenDetails.ftoEndDate') }}</div>

                                        {{ tokenOfferingDetails.endDate }}
                                    </div>

                                    <div class="side-content__column side-content__column--time">
                                        <div class="side-content__title">{{ $t('tokenDetails.time') }}</div>

                                        {{ tokenOfferingDetails.endTime }}
                                    </div>
                                </div>


                                <div class="side-content__row">
                                    <div class="side-content__column">
                                        <div class="side-content__title">{{ $t('tokenDetails.ftoLockDate') }}</div>

                                        {{ tokenOfferingDetails.lockDate }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                </wallet-form>
            </div>
        </section>
    </div>
</template>

<script>
// 3rd party
import {
    mapActions,
    mapGetters,
} from 'vuex';

import {
    format,
    isWithinInterval,
} from '@shared/utils/dates';

import {
    bcmul,
} from 'locutus/php/bc';

import axios from 'axios';

// Socios variable
import socios from '@webapp/socios.json';

// Config
import {
    findErrorBy,
} from '@shared/utils/error.js';

// Local Types
import localEpicTypes from '@webapp/epics/types.js';
import localStoreTypes from '@webapp/store/types.js';
import {
    StringBuilderElement,
} from '@webapp/components/string-builder';

// Shared Types
import sharedEpicTypes from '@shared/epics/types.js';
import {
    RegulationType,
} from '@shared/store/modules/wallet/types';

// Helpers
import {
    formatNumber,
    minimumOfTwoDecimals,
    formatPrice,
    truncateValueToDecimalPlaces,
    ceilFractionalDigits,
} from '@shared/utils/formatter.js';
import {
    isEmpty,
} from '@shared/utils/general';
import apiUrl from '@webapp/helpers/api-url.js';
import {
    goBack,
} from '@webapp/helpers/router';

// Mixins
import amountMixin from '@webapp/helpers/amount-mixin.js';
import userRestrictionMixin from '@webapp/helpers/user-restriction-mixin';

// Shared Modules
import {
    EventNames,
} from '@shared/utils/analytics-keys';

// Components
import walletForm from '@webapp/components/wallet/wallet-form.vue';
import exchangeRate from '@webapp/components/exchange-rate/exchange-rate.vue';
import partnerLogo from '@webapp/components/partner-logo/partner-logo.vue';
import backButton from '@webapp/components/back-button/back-button.vue';
import tokenPriceChart from '@webapp/components/token-price-chart/token-price-chart.vue';
import contextMenu from '@webapp/components/context-menu.vue';

export default {
    name: 'buy-sell',
    components: {
        walletForm,
        exchangeRate,
        partnerLogo,
        backButton,
        tokenPriceChart,
        contextMenu,
    },
    mixins: [
        amountMixin,
        userRestrictionMixin,
    ],

    beforeRouteEnter(_to, { path: fromPath }, next) {
        next(async(vm) => {
            // Resetting ledger summary just in case the call is not made in centralizedWallet() watcher. Done to avoid showing previous balances
            vm.resetLedgerOverview();

            const movementType = vm.isSellPage ? 'credit' : 'debit';

            const batchTypes = {
                [vm.isFTOPage]: 'fto_purchase',
                [vm.isLTOPage]: 'locker_fto_purchase',
                [vm.isSellPage]: 'marketplace_sale',
                [vm.isBuyPage && !vm.isFTOPage]: 'marketplace_purchase',
            };

            await vm.getWallet({
                chilizCurrencyId: socios.chilizCurrencyId,
            });

            await vm.fetchWalletRemainingLedger({
                batchType: batchTypes[Boolean(true)],
                movementType,
            });

            // Load markets in order to refetch current ticker prices
            await vm.fetchAvailableMarkets({
                convertToCurrencies: [vm.centralizedWallet.altCurrency.id],
            });

            if (vm.isTradingRestricted) {
                vm.setModal({
                    isClosable: false,
                    isVisible: true,
                    image: require('@webapp/assets/globe.webp'),
                    title: vm.$t('partner.tradingRestrictions'),
                    messages: [
                        {
                            text: vm.$t('partner.tradingRestrictionsInfo'),
                        },
                    ],
                    acceptButton: {
                        text: vm.$t('global.button.goBack'),
                        action: () => {
                            goBack(vm, fromPath);
                            vm.resetModal();
                        },
                    },
                });

                return;
            }

            if (vm.shouldShowLimitsInfo) {
                if (vm.isBuyPage) {
                    await vm.fetchHoldingLimit({
                        currencyId: vm.ftCurrency.id,
                    });
                }

                await vm.fetchHoldingPeriods({
                    currencyId: vm.ftCurrency.id,
                    batchType: batchTypes[Boolean(true)],
                });
            }

            vm.checkTextLength();

            vm.isInit = false;
        });
    },

    props: {
        title: {
            type: String,
            default: '',
        },
        isSellPage: {
            type: Boolean,
            default: false,
        },
        isFT: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            amount: 0,
            tokenAmount: 0,
            tokenAmountFormatted: '0',
            balance: 0,
            rate: 0,
            rateInAltCurrency: 0,
            remaining: 0,
            cryptoCurrency: {
                id: '',
                name: '',
                decimalDetail: 0,
            },
            fiatCurrency: {
                symbol: '',
                shortCode: '',
                id: '',
                decimalDetail: 0,
            },
            price: 0,
            altCurrencyPrice: '0',
            isTextLong: false,
            processStartedAt: '',
            initialEstimates: {
                orderPrice: 0,
                paymentTradingMarginAmount: 0,
                paymentAmount: 0,
                paymentTotalAmount: 0,
                orderFinalAmount: 0,
                paymentFeeAmount: 0,
                orderFeeAmount: 0,
            },
            estimation: {
                orderPrice: 0,
                paymentTradingMarginAmount: 0,
                paymentAmount: 0,
                paymentTotalAmount: 0,
                orderFinalAmount: 0,
                paymentFeeAmount: 0,
                orderFeeAmount: 0,
            },
            timeOut: null,
            isFeeCalculating: false,
            isRequestFail: false,
            confirmationData: {},
            triggerNotEnoughModal: false,
            areTermsAccepted: false,
            isInit: true,
        };
    },
    computed: {
        ...mapGetters([
            'currencyCHZ',
            'currencyById',
            'currencyConversionRates',
            'getCurrencyConversion',
            'voteTokensByPartnerTokenId',
            'preferredFiatCurrency',
            'getTranslatedStr',
            'voteTokenOfferingsByStatusAndTokenId',
            'userDetails',
            'userId',
            'getLatestSimpleValidationError',
            'isFtoRestrictedForUser',
            'currentRegulation',
            'kycTierLevel',
            'isPartnerApp',
            'userId',
            'partnerAppData',
            'partnerAppEmbedCustomization',
        ]),

        ...mapGetters('partners', [
            'partnerById',
            'partnerId',
        ]),

        ...mapGetters('wallet', [
            'centralizedWallet',
            'decentralizedLedgerByToken',
            'isChzAllowed',
            'remainingLedgerLimit',
            'regulatoryRestrictionLimits',
            'hasRegulatoryRestrictions',
            'getHoldingLimits',
            'getHoldingPeriodsForCurrency',
            'holdingPeriodsDecentralized',
            'ledgerOverview',
        ]),

        ...mapGetters('voteTokens', [
            'tokenPriceByPartnerId',
            'isTokenPurchaseRestricted',
            'isTokenSaleRestricted',
        ]),

        ...mapGetters('marketplace', [
            'availableMarkets',
            'buyOrderEstimate',
            'sellOrderEstimate',
            'createBuyOrderResponse',
            'createSellOrderResponse',
        ]),

        ...mapGetters('remoteConfig', ['remoteConfigByKey']),

        ...mapGetters(['defaultCurrency', 'getCurrencyShortCodeFormatted']),

        ledgerBalance() {
            const {
                totalBalance,
                tradableBalance,
                nonTradableBalance,
            } = this.ledgerOverview;

            return {
                available: tradableBalance || '0',
                locked: nonTradableBalance || '0',
                total: totalBalance || '0',
            };
        },

        partner() {
            return this.$route.params.id ? this.partnerById(this.$route.params.id) : {};
        },

        mainBalance() {
            return this.centralizedWallet.plainBalance;
        },

        tokenPrice() {
            return this.tokenPriceByPartnerId(this.partner, this.centralizedWallet.currency.id).tokenPrice;
        },

        balanceText() {
            if (this.isSellPage) {
                return `${this.$t('buyTokens.availableBalance')}: ${this.ledgerBalance.available} ${this.ftCurrency.symbol}`;
            }

            const {
                balance,
                altCurrencyBalance,
            } = this.centralizedWallet;

            return `${this.$t('buyTokens.walletBalance')}: ${balance} ${this.isChzAllowed ? `= ${altCurrencyBalance}` : ''}`;
        },

        altCurrencyBalance() {
            return formatNumber(this.centralizedWallet.plainAltCurrencyBalance);
        },

        description() {
            if (this.isSellPage) {
                return this.$t('sellTokens.howManyTokensToSell', {
                    name: this.partner.shortName,
                });
            }

            return this.$t('buyTokens.howManyTokensToBuy', {
                name: this.partner.shortName,
            });
        },

        amountTitle() {
            if (this.isSellPage) {
                return this.$t('sellTokens.amountToSell');
            }

            return this.$t('buyTokens.amountToPay');
        },

        isBuyingRestricted() {
            if (this.isFTOPage) {
                return this.isFtoRestrictedForUser(this.token);
            }

            if (this.isBuyPage) {
                return this.isTokenPurchaseRestricted(this.market.baseCurrency);
            }

            return false;
        },

        isSellingRestricted() {
            return this.isSellPage && this.isTokenSaleRestricted(this.market.baseCurrency);
        },

        isTradingRestricted() {
            if (this.isFTOPage) {
                return this.isBuyingRestricted;
            }

            return this.isSellingRestricted || this.isBuyingRestricted;
        },

        conversionRateInfo() {
            return this.rate ? `1 $${this.ftCurrency.shortCode} = ${formatPrice(this.rate, this.centralizedCurrencyShortCodeFormatted, true)}` : '';
        },

        centralizedCurrencyShortCodeFormatted() {
            return this.centralizedWallet.currency.shortCodeFormatted;
        },

        token() {
            return this.voteTokensByPartnerTokenId(this.partner.tokenId) || {};
        },

        ftCurrency() {
            return this.currencyById(this.token.currencyId) || {};
        },

        shortText() {
            return this.tokenDetails.description.length > 100 ? `${this.tokenDetails.description.slice(0, 60)}...` : this.tokenDetails.description;
        },

        rawValue() {
            const value = bcmul((Number(this.tokenAmount) || 0), this.rate, this.centralizedWallet.currency.decimalDetail);

            return isNaN(value) ? 0 : value;
        },

        formattedValue() {
            const value = minimumOfTwoDecimals(Number(this.tokenAmount) * ceilFractionalDigits(this.rate));

            return formatPrice(value);
        },

        isInputDisabled() {
            if (!this.isSellPage && !this.isFT) {
                return this.tokenOfferingDetails.endDate === '--' ||
                    new Date(this.tokenOfferings[0].endDate) < new Date() ||
                    !this.conversionRateInfo;
            }

            return false;
        },

        isButtonDisabled() {
            return this.isFeeCalculating ||
                Number(this.tokenAmount) <= 0 ||
                !this.areTermsAccepted ||
                this.areLimitsExceeded ||
                !this.hasEnoughBalance;
        },

        timer() {
            return this.remoteConfigByKey('ftoPaymentTimeoutSeconds');
        },

        tokenDetails() {
            if (this.token) {
                return {
                    description: this.getTranslatedStr(this.token, 'description', this.token.description || '--'),
                    supply: formatNumber(this.token.supply),
                    acquiringLimit: formatNumber(this.token.acquiringLimit),
                };
            }

            return {
                description: '',
                supply: 0,
                acquiringLimit: 0,
            };
        },

        tokenOfferings() {
            return this.voteTokenOfferingsByStatusAndTokenId(['opened', 'published'], this.token.id);
        },

        formattedMarginAmount() {
            return formatPrice(this.isSellPage ? this.estimation.orderTradingMarginAmount * -1 : this.estimation.paymentTradingMarginAmount);
        },

        formattedFeeAmount() {
            return formatPrice(this.isSellPage ? this.estimation.orderFeeAmount * -1 : this.estimation.paymentFeeAmount);
        },

        tokenRatesInCurrency() {
            return {
                main: formatPrice(this.rate, this.centralizedWallet.currency.shortCodeFormatted, true),
                alt: formatPrice(this.rateInAltCurrency, this.centralizedWallet.altCurrency.shortCodeFormatted, true),
            };
        },

        tokenOfferingDetails() {
            if (this.tokenOfferings &&
                this.tokenOfferings.length &&
                isWithinInterval(Date.now(), {
                    start: new Date(this.tokenOfferings[0].publicationDate),
                    end: new Date(this.tokenOfferings[0].endDate),
                }) &&
                ['opened', 'published'].includes(this.tokenOfferings[0].status)) {
                return {
                    startDate: format(new Date(this.tokenOfferings[0].startDate), 'dateShort'),
                    endDate: format(new Date(this.tokenOfferings[0].endDate), 'dateShort'),
                    startTime: `${format(new Date(this.tokenOfferings[0].startDate), 'HH:mm')} CET`,
                    endTime: `${format(new Date(this.tokenOfferings[0].endDate), 'HH:mm')} CET`,
                    lockDate: format(new Date(this.tokenOfferings[0].lockDate), 'dateShort'),
                    availableSupply: formatNumber(this.tokenOfferings[0].supply - this.tokenOfferings[0].supplySold),
                };
            }

            return {
                startDate: '--',
                endDate: '--',
                lockDate: '--',
                startTime: '--',
                endTime: '--',
                availableSupply: '--',
            };
        },

        market() {
            return this.availableMarkets.find(({ partnerId }) => partnerId === this.partner.id) ?? {};
        },

        symbol() {
            if (this.partner) {
                return this.partner.shortName || '';
            }

            return this.marketData.symbol || '';
        },

        headerText() {
            if (this.isSellPage) {
                return this.$t(
                    'sellTokens.sell',
                    {
                        name: this.symbol,
                    }
                );
            }

            return this.$t('marketplace.trading.buyFanTokens');
        },

        buttonText() {
            if (this.isSellPage) {
                return this.$t(
                    'sellTokens.sell',
                    {
                        name: this.symbol,
                    }
                );
            }

            return this.$t('buyTokens.pay', {
                shortCode: this.centralizedCurrencyShortCodeFormatted,
            });
        },

        genericConfirmationData() {
            return {
                title: this.isSellPage ? this.$t('sellTokenError.title') : this.$t('buyTokenError.title'),
                message: this.isSellPage ? this.$t('sellTokenError.message') : this.$t('buyTokenError.message'),
            };
        },

        isLTOPage() {
            return !this.isFT && !this.partner.isSigned;
        },

        isFTOPage() {
            return !this.isFT && this.partner.isSigned;
        },

        isBuyPage() {
            return !this.isSellPage;
        },

        termsTextList() {
            return [
                {
                    text: this.isSellPage ? this.$t('sellTokens.terms') : this.$t('buyTokens.terms'),
                    element: StringBuilderElement.Span,
                },
            ];
        },

        tokenHoldingLimit() {
            const {
                limit = '',
                remainingAmountBeforeLimit = '',
                limitAmountInExpressedCurrency = '',
                limitExpressedCurrencyId = '',
            } = this.getHoldingLimits(this.ftCurrency.id);

            return {
                total: {
                    plain: Number(limit),
                    formatted: `${ceilFractionalDigits(limit)} ${this.ftCurrency.symbol}`,
                },
                remaining: {
                    plain: Number(remainingAmountBeforeLimit),
                    formatted: `${ceilFractionalDigits(remainingAmountBeforeLimit)} ${this.ftCurrency.symbol}`,
                },
                maxHoldingAmount: {
                    plain: Number(limitAmountInExpressedCurrency),
                    formatted: formatPrice(limitAmountInExpressedCurrency, this.getCurrencyShortCodeFormatted(limitExpressedCurrencyId), true),
                },
            };
        },

        hasHoldingLimit() {
            return this.tokenHoldingLimit.total.plain > 0;
        },

        tokenHoldingPeriods() {
            return this.getHoldingPeriodsForCurrency(this.ftCurrency.id);
        },

        hasTokenHoldingPeriods() {
            return !isEmpty(this.tokenHoldingPeriods);
        },

        hasTokensOnHold() {
            return this.hasTokenHoldingPeriods && Number(this.tokenAmount) > Number(this.tokenHoldingPeriods.remainingAmountBeforeLimit);
        },

        hasEnoughBalance() {
            if (this.isSellPage) {
                return Number(this.tokenAmount) <= this.ledgerBalance.available;
            }

            // In the case of buy page, allowing the user to go through to see the not enough modal (for top-up conversion)
            return true;
        },

        regulatoryLimits() {
            const regulationType = ({
                [this.isSellPage]: RegulationType.MarketplaceSale,
                [this.isFTOPage]: RegulationType.FtoPurchase,
                [this.isBuyPage && !this.isFTOPage]: RegulationType.MarketplaceBuy,
            })[Boolean(true)];

            return this.regulatoryRestrictionLimits[regulationType] ?? {};
        },

        hasDailyLimits() {
            return this.regulatoryLimits.limitAmount > 0;
        },

        isDailyLimitExceeded() {
            return Number(this.rawValue) > Number(this.regulatoryLimits.remainingAmountBeforeLimit);
        },

        isHoldingLimitExceeded() {
            return this.isBuyPage && this.hasHoldingLimit && Number(this.tokenAmount) > Number(this.tokenHoldingLimit.remaining.plain);
        },

        areLimitsExceeded() {
            return this.shouldShowLimitsInfo && (
                this.isDailyLimitExceeded ||
                this.isHoldingLimitExceeded ||
                this.hasTokensOnHold
            );
        },

        shouldShowLimitsInfo() {
            return this.hasRegulatoryRestrictions;
        },

        shouldShowInputValidation() {
            return this.shouldShowLimitsInfo || this.isSellPage;
        },

        inputValidationText() {
            if (!this.hasEnoughBalance) {
                return this.$t('buySellTokens.insufficientBalance');
            }

            if (this.isHoldingLimitExceeded) {
                return this.$t('buySellTokens.remainingHoldingLimit', {
                    limit: this.tokenHoldingLimit.remaining.formatted,
                });
            }

            if (this.isSellPage && this.hasTokensOnHold) {
                const {
                    configuredPeriodInDays,
                    remainingAmountBeforeLimit,
                } = this.tokenHoldingPeriods;

                return this.$t('sellTokens.tokensOnHold', {
                    noOfTokens: Number(this.tokenAmount) - Number(remainingAmountBeforeLimit),
                    noOfDays: configuredPeriodInDays,
                    period: this.$t(`global.${configuredPeriodInDays > 1 ? 'days' : 'day'}`).toLowerCase(),
                });
            }

            return this.showShouldLimitsInfo && this.hasDailyLimits
                ? this.$t('buySellTokens.remainingDailyLimit', {
                    limit: this.regulatoryLimits.formatted?.remainingAmountBeforeLimit,
                }) : '';
        },

        disclaimerConfig() {
            if (!this.shouldShowLimitsInfo) {
                return {
                    textList: [],
                };
            }

            return {
                isHighlighted: this.areLimitsExceeded,
                textList: [
                    ...(this.isSellPage && this.hasDailyLimits ? [
                        this.$t('sellTokens.sellingLimit.disclaimer', {
                            limit: this.regulatoryLimits.formatted?.limitAmount,
                        }),
                    ] : []),

                    ...((this.isBuyPage || this.isFTOPage) ? [
                        ...(this.hasDailyLimits ? [
                            this.$t('buyTokens.spendingLimit.disclaimer', {
                                limit: this.regulatoryLimits.formatted?.limitAmount,
                            }),
                        ] : []),
                        ...(this.hasHoldingLimit ? [
                            this.$t('buyTokens.holdingLimit.disclaimer', {
                                limit: this.tokenHoldingLimit.total.formatted,
                            }),
                        ] : []),
                    ] : []),

                    ...(this.hasTokenHoldingPeriods ? [
                        this.$t('buySellTokens.holdingPeriod.disclaimer', {
                            periodLength: this.holdingPeriodsDecentralized.configuredPeriodInDays ?? 0,
                            periodType: this.$t('buySellTokens.holdingPeriod.periodType'),
                        }),
                    ] : []),
                ],
            };
        },

        contextMenuItems() {
            return [
                ...(this.hasTokenHoldingPeriods ? [
                    {
                        text: this.$t('buySellTokens.holdingPeriod.title'),
                        action: () => {
                            this.showLimitsInfo({
                                title: this.$t('buySellTokens.holdingPeriod.title'),
                                message: this.$t('buySellTokens.holdingPeriod.desc', {
                                    days: this.holdingPeriodsDecentralized.configuredPeriodInDays,
                                }),
                            });
                        },
                    },
                ] : []),

                ...(this.isSellPage && this.hasDailyLimits ? [
                    {
                        text: this.$t('sellTokens.sellingLimit.title'),
                        action: () => {
                            this.showLimitsInfo({
                                title: this.$t('sellTokens.sellingLimit.title'),
                                message: this.$t('sellTokens.sellingLimit.desc', {
                                    limit: this.regulatoryLimits.formatted?.limitAmount,
                                }),
                            });
                        },
                    },
                ] : []),

                ...((this.isBuyPage || this.isFTOPage) ? [
                    ...(this.hasHoldingLimit ? [
                        {
                            text: this.$t('buyTokens.holdingLimit.title'),
                            action: () => {
                                this.showLimitsInfo({
                                    title: this.$t('buyTokens.holdingLimit.title'),
                                    message: this.$t('buyTokens.holdingLimit.desc', {
                                        limit: this.tokenHoldingLimit.total.formatted,
                                    }),
                                });
                            },
                        },
                    ] : []),
                    ...(this.hasDailyLimits ? [
                        {
                            text: this.$t('buyTokens.spendingLimit.title'),
                            action: () => {
                                this.showLimitsInfo({
                                    title: this.$t('buyTokens.spendingLimit.title'),
                                    message: this.$t('buyTokens.spendingLimit.desc', {
                                        limit: this.regulatoryLimits?.formatted.limitAmount,
                                    }),
                                });
                            },
                        },
                    ] : []),
                ] : []),
            ];
        },

        currencyIds() {
            return [
                this.centralizedWallet.currency.id,
                this.ftCurrency.id,
            ];
        },
    },
    watch: {
        createBuyOrderResponse: 'onActionResponse',
        createSellOrderResponse: 'onActionResponse',
        buyOrderEstimate(payload) {
            this.estimation = payload;
            this.isFeeCalculating = false;
        },
        sellOrderEstimate(payload) {
            this.estimation = payload;
            this.isFeeCalculating = false;
        },
        getLatestSimpleValidationError({ errors = [] }) {
            const is404Error = errors.some((error) => error.status === 404);

            const topLevelLimitsError = findErrorBy('type', 'code', sharedEpicTypes.ON_ANOTHER_USER_LIMIT_EXCEEDED);
            const exceededLimitError = findErrorBy('type', 'code', sharedEpicTypes.ON_EXCEEDED_TOKEN_LIMIT_ERROR);
            const isTopLevelLimitsError = errors.some(({
                code,
                status,
            }) => code === topLevelLimitsError && status === 400);
            const isExceededLimitError = errors.some(({
                code,
                status,
            }) => code === exceededLimitError && status === 400);

            if (errors.length && !is404Error) {
                if (isExceededLimitError) {
                    this.isRequestFail = true;
                    this.showExceedLimitErrorModal();
                } else if (isTopLevelLimitsError) {
                    this.isRequestFail = true;
                    this.confirmationData = this.genericConfirmationData;
                    this.showConfirmationModal();
                } else {
                    const errorsList = errors.reduce((acc, {
                        title,
                    }) => acc + (errors.length > 1 ? `<p>${title}</p>` : title), '');

                    this.$notify({
                        type: 'error',
                        text: errorsList,
                        duration: 4000,
                    });
                }
            }

            this.showAppLoader({
                isVisible: false,
            });
        },

        market() {
            if (this.isFTOPage) {
                return;
            }

            this.setTickerRate();
        },
        currencyConversionRates() {
            const {
                altCurrency,
                currency,
            } = this.centralizedWallet;

            const tokenToCentralizedCurrency = this.getCurrencyConversion(this.ftCurrency.id, currency.id);
            const mainToAltCurrencyRates = this.getCurrencyConversion(currency.id, altCurrency.id);

            if (this.isSellPage) {
                this.price = minimumOfTwoDecimals(this.tokenAmount - this.ledgerBalance.total);
                this.altCurrencyPrice = bcmul(this.price, Number(this.rate), altCurrency.decimalDetail);
            } else {
                this.price = minimumOfTwoDecimals(this.rawValue - this.mainBalance);
                this.altCurrencyPrice = bcmul(this.price, Number(mainToAltCurrencyRates.rate), altCurrency.decimalDetail);
            }

            if (Object.keys(tokenToCentralizedCurrency).length > 0) {
                this.processStartedAt = tokenToCentralizedCurrency.date;

                // Need to set the rates for FTO here since there are no available markets
                if (this.isFTOPage) {
                    this.rate = Number(tokenToCentralizedCurrency.rate);
                    this.rateInAltCurrency = this.tokenPrice.rawAltValue;
                }
            } else if ((this.isBuyPage || this.isFTOPage) && Object.keys(mainToAltCurrencyRates.length > 0)) {
                console.error(this.price);
            }

            if (this.triggerNotEnoughModal) {
                this.showNotEnoughAmountModal();

                this.triggerNotEnoughModal = false;
            }
        },
        currencyCHZ: {
            immediate: true,
            handler(newValue) {
                if (newValue) {
                    this.cryptoCurrency.id = newValue.id;
                    this.cryptoCurrency.name = newValue.shortCode;
                    this.cryptoCurrency.decimalDetail = newValue.decimalDetail;
                }
            },
        },
        partner: {
            immediate: true,
            handler() {
                document.title = this.isSellPage
                    ? `${this.partner.shortName} | Sell Fan Token | Socios.com`
                    : `${this.partner.shortName} | ${this.isFT ? 'Buy Fan Token' : 'Fan Token Offering'} | Socios.com`;
            },
        },

        // Need to wait until the ledger is fetched to know which currencies to use, otherwise we risk sending undefined
        currencyIds: {
            immediate: true,
            handler([
                centralizedWalletCurrencyId,
                ftCurrencyId,
            ]) {
                if (centralizedWalletCurrencyId && ftCurrencyId) {
                    const currenciesFromList = [ftCurrencyId];
                    const currenciesToList = [centralizedWalletCurrencyId];

                    this.getCurrencyConversionRates({
                        currenciesFromList,
                        currenciesToList,
                    });

                    const { id: ledgerId } = this.decentralizedLedgerByToken(ftCurrencyId);

                    /*
                        Need to fetch balances for sell page. Avoid calling if no ledger ID was found, which means the user doesn't have any tokens.
                        We can use defaults set in ledgerBalance()
                    */
                    if (this.isSellPage && ledgerId) {
                        this.fetchLedgerOverview({
                            ledgerId,
                            details: [],
                        });
                    }
                }
            },
        },
    },
    methods: {
        ...mapActions({
            setModal: localStoreTypes.SET_MODAL,
            resetModal: localStoreTypes.RESET_MODAL,
            getCurrencyConversionRates: sharedEpicTypes.GET_CURRENCY_CONVERSION_RATES,
            fetchSellOrderEstimate: localEpicTypes.GET_SELL_ORDER_ESTIMATE,
            fetchBuyOrderEstimate: localEpicTypes.GET_BUY_ORDER_ESTIMATE,
            createBuyOrder: localEpicTypes.CREATE_BUY_ORDER,
            getWallet: sharedEpicTypes.GET_WALLET,
            createSellOrder: localEpicTypes.CREATE_SELL_ORDER,
            showAppLoader: localStoreTypes.SET_APP_LOADER,
        }),

        ...mapActions('wallet', [
            'fetchHoldingLimit',
            'fetchHoldingPeriods',
            'fetchWalletRemainingLedger',
            'fetchLedgerOverview',
            'resetLedgerOverview',
        ]),

        ...mapActions('marketplace', ['fetchAvailableMarkets']),

        onToggledTerms({ value }) {
            this.areTermsAccepted = value;
        },

        preventDecimalInput(event) {
            const charCode = event.keyCode;

            // Prevent dot or comma input
            if (charCode === 46 || charCode === 44) {
                event.preventDefault();
            }
        },
        checkTextLength() {
            this.isTextLong = this.tokenDetails.description.length > 100;
        },
        showMore() {
            this.isTextLong = false;
        },
        setTickerRate() {
            this.processStartedAt = format(Date.now(), 'standardDateTime');
            const {
                ticker: {
                    lastPrice = '',
                    convertedPrices = {},
                } = {},
            } = this.market;
            const { altCurrency } = this.centralizedWallet;

            this.rate = Number(lastPrice);
            this.rateInAltCurrency = Number(convertedPrices?.[altCurrency.id]?.rate ?? 0);
        },
        onRemaining({ remaining }) {
            this.remaining = remaining;
        },
        onChangeTokenAmount(event) {
            const inputValue = event.target.value;

            if (inputValue === '' || Number(inputValue.substring(0, 1)) === 0) {
                this.tokenAmountFormatted = inputValue.substring(1, inputValue.length);
                this.tokenAmount = inputValue.substring(1, inputValue.length);
                this.estimation = this.initialEstimates;
            } else {
                this.tokenAmountFormatted = inputValue || '0';
                this.tokenAmount = inputValue || 0;
            }

            this.tokenAmount = this.tokenAmount.replace(/\D/g, '');
            this.tokenAmountFormatted = this.tokenAmountFormatted.replace(/\D/g, '');

            // This should only be flagged for FT Buy / Sell and not for FTO
            if (this.isFT) {
                this.isFeeCalculating = true;
            }
        },
        fetchEstimates() {
            if (this.isFT && this.tokenAmount > 0) {
                const fetchFrom = this.isSellPage ? 'fetchSellOrderEstimate' : 'fetchBuyOrderEstimate';

                if (this.timeOut) {
                    clearTimeout(this.timeOut);
                    this.timeOut = null;
                }

                const marketId = this.market.id || null;

                this[fetchFrom]({
                    marketId: marketId,
                    userId: this.userId || this.userDetails.id,
                    orderQuantity: this.tokenAmount,
                    // Ensure decimal (7,2) is passed to backend
                    orderPrice: truncateValueToDecimalPlaces(this.rate),
                    processStartedAt: format(Date.now(), 'standardDateTime'),
                });
            }
        },
        finishedTimer() {
            this.resetModal();
            this.$router.push(`/partner/${this.partner.id}`);
        },
        onActionResponse(data) {
            this.showAppLoader({
                isVisible: false,
            });

            this.confirmationData = data;
            this.isRequestFail = false;

            if (this.isPartnerApp && !this.isSellPage) {
                this.$webTrackingInstance?.sendEvent(
                    EventNames.PartnerTokenPurchase,
                    [
                        {
                            key: 'partner',
                            value: this.partnerAppData.id,
                        },
                        {
                            key: 'userId',
                            value: this.userId,
                        },
                        {
                            key: 'amount',
                            value: this.tokenAmountFormatted.toString(),
                        },
                    ]
                );
            }

            this.showConfirmationModal();
        },
        getActiveOffering(token) {
            const voteTokenOfferings = this.voteTokenOfferingsByStatusAndTokenId(['opened', 'published'], token.id);

            return socios.showFto &&
                    voteTokenOfferings.length > 0 &&
                    isWithinInterval(Date.now(), {
                        start: new Date(voteTokenOfferings[0].startDate),
                        end: new Date(voteTokenOfferings[0].endDate),
                    })
                ? voteTokenOfferings[0] : null;
        },
        async proceedButtonAction() {
            if (this.isSellPage) {
                if (Number(this.remainingLedgerLimit) && (Number(this.rawValue) > Number(this.remainingLedgerLimit))) {
                    this.setModal({
                        isVisible: true,
                        componentToLoad: 'components/wallet/wallet-level-up-modal',
                        data: {
                            kycLevel: this.kycTierLevel,
                            type: 'trading',
                        },
                    });

                    return;
                }

                if ((this.ledgerBalance.total - Number(this.tokenAmountFormatted)) < 0) {
                    const currenciesFromList = [this.ftCurrency.id];
                    const currenciesToList = [this.currencyCHZ.id];

                    await this.getCurrencyConversionRates({
                        currenciesFromList,
                        currenciesToList,
                    });

                    this.triggerNotEnoughModal = true;

                    return;
                }

                if (Object.values(this.estimation).some((value) => Number(value) <= 0)) {
                    this.confirmationData = this.genericConfirmationData;
                    this.showConfirmationModal();

                    return;
                }
            }

            if (!this.isSellPage && ((this.mainBalance - Number(this.rawValue)) < 0)) {
                const currenciesFromList = [this.centralizedWallet.currency.id];
                const currenciesToList = [this.centralizedWallet.altCurrency.id];

                await this.getCurrencyConversionRates({
                    currenciesFromList,
                    currenciesToList,
                });

                this.triggerNotEnoughModal = true;

                return false;
            }

            if (this.isFT) {
                const marketId = this.market.id || null;

                this.showAppLoader({
                    isVisible: true,
                    hasOpacity: true,
                });

                if (this.isSellPage) {
                    this.createSellOrder({
                        marketId: marketId,
                        userId: this.userId || this.userDetails.id,
                        timeInForce: 'good_till_cancelled',
                        sellOrderCost: Object.assign({}, this.estimation),
                    });

                    return false;
                }

                this.createBuyOrder({
                    marketId: marketId,
                    userId: this.userId || this.userDetails.id,
                    timeInForce: 'good_till_cancelled',
                    buyOrderCost: Object.assign({}, this.estimation),
                });

                return false;
            }

            let referenceNumber = '';
            const voteTokenOffering = this.getActiveOffering(this.token);

            this.showAppLoader({
                isVisible: true,
                hasOpacity: true,
            });

            try {
                const result = await axios.post(`${apiUrl()}/vote-token-offering/${voteTokenOffering.id}/buy`, {
                    paidAmount: this.rawValue.toString(),
                    boughtVoteTokenAmount: this.tokenAmountFormatted.toString(),
                    bonusVoteTokenAmount: '0',
                    processStartedAt: this.processStartedAt,
                });

                referenceNumber = result.data.data.referenceNumber;

                await this.getWallet({
                    chilizCurrencyId: socios.chilizCurrencyId,
                });

                if (this.isPartnerApp && !this.isSellPage) {
                    this.$webTrackingInstance?.sendEvent(
                        EventNames.PartnerTokenPurchase,
                        [
                            {
                                key: 'partner',
                                value: this.partnerAppData.id,
                            },
                            {
                                key: 'userId',
                                value: this.userId,
                            },
                            {
                                key: 'amount',
                                value: this.tokenAmountFormatted.toString(),
                            },
                        ]
                    );
                }

                this.confirmationData = {
                    referenceNumber: referenceNumber,
                    title: this.$t('buyTokenSuccess.purchaseCompleted'),
                    message: this.$t('buyTokenSuccess.congratulations', {
                        name: this.partner.shortName,
                        value: this.tokenAmountFormatted,
                    }),
                    initialQuantity: this.tokenAmountFormatted,
                };

                this.isRequestFail = false;
                this.showConfirmationModal();
            } catch (error) {
                const {
                    response: {
                        status,
                        data: { errors = [] } = {},
                    } = {},
                } = error;
                const exceededLimitErrorCode = findErrorBy('type', 'code', sharedEpicTypes.ON_EXCEEDED_TOKEN_LIMIT_ERROR);
                const VoteOfferingsFinishedTokensError = findErrorBy('type', 'code', sharedEpicTypes.ON_VOTE_TOKEN_OFFERINGS_FINISHED_TOKENS_ERROR);
                const VoteOfferingsOverThrottleError = findErrorBy('type', 'code', sharedEpicTypes.ON_VOTE_TOKEN_OFFERINGS_OVER_THROTTLE_ERROR);
                const exceededLimitError = errors.find((error) => error.code === exceededLimitErrorCode);
                const hasExceededLimitError = exceededLimitError && status === 400;
                const hasVoteOfferingsFinishedTokensError = errors.find((error) => error.code === VoteOfferingsFinishedTokensError) && status === 400;
                const hasVoteOfferingsOverThrottleError = errors.find((error) => error.code === VoteOfferingsOverThrottleError) && status === 400;

                this.isRequestFail = true;

                if (hasExceededLimitError) {
                    this.showExceedLimitErrorModal();
                } else {
                    if (hasVoteOfferingsFinishedTokensError) {
                        this.confirmationData = {
                            title: this.$t('notEnoughFanTokens.title'),
                            message: this.$t('notEnoughFanTokens.message', {
                                name: this.partner.shortName,
                                tokensLeft: formatNumber(voteTokenOffering.supply - voteTokenOffering.supplySold),
                                userTokenAmount: this.tokenAmountFormatted,
                            }),
                            action: 'close',
                        };
                    } else if (hasVoteOfferingsOverThrottleError) {
                        this.confirmationData = {
                            title: this.$t('fanTokensOverThrottle.title'),
                            message: this.$t('fanTokensOverThrottle.message'),
                            action: 'close',
                        };
                    } else {
                        this.confirmationData = this.genericConfirmationData;
                    }

                    this.showConfirmationModal();
                }
            }

            this.showAppLoader({
                isVisible: false,
                hasOpacity: true,
            });
        },

        async showExceedLimitErrorModal() {
            await this.fetchHoldingLimit({
                currencyId: this.ftCurrency.id,
            });

            this.setModal({
                isClosable: true,
                isVisible: true,
                image: require('@webapp/assets/statuses/error.webp'),
                title: this.$t('buyTokens.fto.maxLimitExceededTitle'),
                messages: [
                    {
                        text: this.$t('buyTokens.fto.maxLimitExceededMessage', {
                            shortCode: this.partner.shortName,
                            maxHoldingAmount: this.tokenHoldingLimit.maxHoldingAmount.formatted,
                        }),
                    },
                ],
                acceptButton: {
                    text: this.$t('tokenHuntExceedLimit.parnterBtn', {
                        shortCode: this.partner.shortName,
                    }),
                    action: () => {
                        this.$router.push(`/partner/${this.partner.id}`);
                        this.resetModal();
                    },
                },
            });
        },

        showConfirmationModal() {
            this.setModal({
                isVisible: true,
                componentToLoad: 'components/fto-modals/confirmation-modal',
                data: {
                    confirmation: this.confirmationData,
                    isSellPage: this.isSellPage,
                    isRequestFail: this.isRequestFail,
                    rate: this.rate,
                    partner: this.partner,
                },
            });
        },

        showNotEnoughAmountModal() {
            this.setModal({
                isVisible: true,
                componentToLoad: 'components/fto-modals/not-enough-amount-modal',
                data: {
                    isSellPage: this.isSellPage,
                    partner: this.partner,
                    balance: this.isSellPage ? this.ledgerBalance.total : this.mainBalance,
                    fiatBalance: this.centralizedWallet.plainAltCurrencyBalance,
                    price: this.price,
                    rate: this.rate,
                    fiatPrice: this.altCurrencyPrice,
                },
            });
        },

        showLimitsInfo({
            title = '',
            message = '',
        }) {
            this.setModal({
                isVisible: true,
                isClosable: true,
                image: require('@webapp/assets/info.webp'),
                title,
                messages: [
                    {
                        text: message,
                    },
                ],
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.fto-form {
    display: flex;
    flex-direction: column;
    align-items: center;

    &__input {
        display: flex;
        width: 100%;
        flex-direction: column;
        justify-content: center;
        color: $daintree-color;
        font-size: 1.6rem;
        line-height: 1;

        input {
            border: none;
            outline: none;
            font-weight: 700;
            font-size: 3rem;
            line-height: 3rem;
            text-align: center;
            font-family: "Nunito";
            appearance: textfield;
            box-shadow: none;

            &::-webkit-outer-spin-button,
            &::-webkit-inner-spin-button {
                appearance: none;
                margin: 0;
            }

            &:disabled {
                background: transparent;
            }
        }

        &--orange,
        &--blue {
            color: $cyprus-color;
            position: relative;
            border-radius: 1rem;
            background: rgba($pizazz-color, 0.05);
            border: 0.1rem solid $pizazz-color;
            padding: 3.2rem 0 3.2rem;
            top: -1.3rem;

            span {
                font-size: 2rem;
            }

            input {
                background: transparent;
            }
        }

        &--blue {
            background: rgba($blue-ribbon-color, 0.05);
            border: 0.1rem solid $blue-ribbon-color;
        }

        &--error {
            @include input-color($torch-red-color);
        }

        &--padding-bottom {
            padding-bottom: 1.5rem;
        }
    }

    &__fees {
        padding: 1rem 0;

        &-fee {
            color: $cyprus-color;
            font-size: 1.2rem;
            line-height: 1.2rem;
            padding-bottom: 1rem;

            span {
                font-weight: 700;
            }
        }
    }
}

.input-validation {
    padding: 0.5rem 0 2rem 0;
    font-size: 1.2rem;
    height: 10px;
}

.balance {
    color: $cyprus-color;
    font-size: 1.2rem;
    line-height: 1.1rem;

    &--top {
        position: absolute;
        margin-top: -4rem;
    }
}

.exchange-rate {
    z-index: 1;
    max-width: 1.51rem;
}

.partner-logo {
    width: 5.1rem;
    height: 5.1rem;
}

.side-content {
    &__row {
        display: flex;
        align-items: center;
        text-align: left;
        flex-wrap: wrap;
        color: $cyprus-color;
        font-size: 1.3rem;
        padding: 2.6rem 0 2.2rem;
        border-bottom: 0.1rem solid $gainsboro-color;

        &:first-of-type {
            padding-top: 1.2rem;
        }

        &:last-of-type {
            border: none;
        }

        img {
            width: 100%;
        }
    }

    &__chart-timeframe {
        display: block;
        width: 100%;
        text-align: center;
        font-size: 1.1rem;
        padding-top: 1rem;
    }

    &__show-more {
        color: $azure-radiance-color;
        white-space: nowrap;
        cursor: pointer;
    }

    &__column {
        display: flex;
        flex-direction: column;
        min-width: 10rem;

        &--align-right {
            text-align: right;
            margin-left: auto;

            span:first-of-type {
                line-height: 2rem;
                font-size: 2rem;
                font-weight: 700;
            }
        }

        &--time {
            padding-left: 5.5rem;
            min-width: unset;
        }
    }

    &__title {
        width: 100%;
        font-weight: 700;
        padding-bottom: 0.5rem;

        &--padding-top {
            padding-top: 1.5rem;
        }
    }
}
</style>